
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Container, Typography, Box } from '@mui/material';

// components
import Page from '../components/configs/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 500,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 450,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title="INPACT | Login">

      <MHidden width="mdDown">
        <SectionStyle>
          
          <Box sx={{padding: 5}}>
            <img src="static/Logo.svg"
            width={'95%'} alt="login" />
          </Box>

          <Box>
            <img src="https://media.istockphoto.com/vectors/happy-woman-exercising-in-the-park-vector-illustration-in-flat-style-vector-id1139929498?k=20&m=1139929498&s=612x612&w=0&h=mRbKYj7-IJcW2lMh70BpYkc8sLgDC32lK9mZWNZ3nYk="
            width={'95%'} alt="login" />
          </Box>
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Iniciar Sessão
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Introduza as suas credenciais de acesso.</Typography>
          </Stack>
          
          <LoginForm />

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
